import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  @Input() pageTitle! : string;
  @Input() subTitle! : string;
  @Input() breadcrum! : any[];
  @Input() actions! : any[];
  @Input() views!: any[];
  @Output() callAction = new EventEmitter<any>();
  @Output() setView = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  trackActionBy(_index: number, item: any): string {
    return String(item?.action ?? item?.label ?? _index);
  }

}
